module.exports = __webpack_public_path__ + "assets/PerimeterBisectorDetailed.5d3bb628cd6965214c802a1206c594e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/PerimeterBisectorDetailed.png
// module id = 550
// module chunks = 0